import * as React from 'react'

import { Strong } from 'main/ui'

import { Container } from './InfoSection.styles'

interface IProps {
  children: React.ReactNode
  title: string
}

export default function InfoSection(props: IProps) {
  const { children, title } = props

  return (
    <Container>
      <Strong>{title}</Strong>
      {children}
    </Container>
  )
}
